import '../DropPanel/DropPanel';
import './Menu.scss';
import DropPanel from "../DropPanel/DropPanel";
import Delegate from "../../Delegate";
import NP from "../../NP";
import ListBox, {ListBoxItemArgs} from "../ListBox/ListBox";
import {IItem} from "../ListBox/ListItem";

export interface MenuItemArgs extends ListBoxItemArgs {
	IsCancelClose: boolean
}

export default class Menu extends DropPanel {

	private _Items: IItem [];
	private _Selectable: boolean;
	public EvItemSelected: Delegate;
	private _UseSelection: boolean;
	private _IsDense: boolean;


	constructor(settings: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this._Items = [];
		this._Selectable = false;
		this.EvItemSelected = new Delegate();
		this._UseSelection = false;
		this._IsDense = true;
		super._initFields(settings);
	}

	_render()
	{
		this.EvOutMouseDown.add(() => this.hide());
		super._render();
		this.addClass('np-menu');
		NP.addCssClass(this._contentDomNode, 'np-menu__content');

		if (this._UseSelection)
			this._Items.forEach(it => it.FontImage = ' ');

		this.setContent(new ListBox({
			Items: this._Items,
			Class: 'app-menu__items' + (this._IsDense && !NP.isTouchDevice() ? ' app-list--dense': ''),
			Selectable: this._Selectable,
			EvItemClick: (s: ListBox, e: MenuItemArgs) =>
			{
				this.EvItemSelected.fire(this, e);
				if (!e.IsCancelClose)
					this.hide();
				if (this._UseSelection)
					this.setValue(e.Item.getValue());
			}
		}));
	}

	setUseSelection(value: boolean)
	{
		this._UseSelection = value;
	}

	addItems(items: IItem[])
	{
		if (items)
			items.forEach(item => this.addItem(item));
	}

	addItem(value: IItem)
	{
		(this._Content as ListBox).addItem(value);
	}

	getItems()
	{
		return (this._Content as ListBox).getItems();
	}

	getSelectedValues(): any[]
	{
		return this.getItems()
			 .filter(item => item.getIsChecked && item.getIsChecked())
			 .map(item => item.getValue());
	}

	getItem(value: any)
	{
		return (this._Content as ListBox).getItem(value);
	}

	getItemById(id: string)
	{
		return (this._Content as ListBox).getItems().find(x => x.getId() == id);
	}

	setItems(items: IItem[], _clear?: boolean)
	{
		if (this._UseSelection)
			items.forEach(it => it.FontImage = ' ');
		(this._Content as ListBox).setItems(items, _clear);
	}

	getListBox()
	{
		return this._Content;
	}

	clear()
	{
		(this._Content as ListBox).clear();
		this._Items = [];
	}

	removeItem(item: any)
	{
		(this._Content as ListBox).removeItem(item);
	}


	hasVisibleItems()
	{
		return !!(this._Content as ListBox).getItems().find(item => item.getIsVisible());
	}

	setValue(value: any)
	{
		(this._Content as ListBox).getItems().forEach(it => it.setFontImage && it.setFontImage(' '));
		let item = this.getItem(value);
		if (item)
			item.setFontImage(NP.FontImages.check);
	}

	getItemByPropValue(prop: string, value: any)
	{
		return (this._Content as ListBox).getItemByPropValue(prop, value);
	}

	showContextMenu(event: MouseEvent)
	{
		let coords = NP.getMouseCoordinates(event);
		this.showContext(coords.X, coords.Y);
	}

};

NP.Menu = Menu;